// ─── Injection de JSON-LD dynamique (capté par le prérendu SSG) ───────────────
// Pose/retire un bloc <script type="application/ld+json"> dans le <head>, par id.
// Passer `null` retire le bloc s'il existe (utile en navigation SPA).

export function setJsonLd(id: string, data: unknown | null): void {
  const existing = document.getElementById(id) as HTMLScriptElement | null;
  if (data == null) {
    if (existing) existing.remove();
    return;
  }
  const el = existing ?? (() => {
    const s = document.createElement('script');
    s.id = id;
    s.type = 'application/ld+json';
    document.head.appendChild(s);
    return s;
  })();
  el.textContent = JSON.stringify(data);
}

// Construit un BreadcrumbList schema.org à partir d'une liste ordonnée.
export function breadcrumbLd(items: { name: string; url: string }[]): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: it.url,
    })),
  };
}

export const HOME_CRUMB = { name: 'Accueil', url: 'https://wezea.net' };
